// Install an app on a modular smart account (space / user) via AppInstallerFacet.
export async function installApp(params) {
    const { smartAccount, appRegistryDapp, fnArgs } = params;
    const { target, appAddress, price, signer } = fnArgs;
    if (!appRegistryDapp) {
        throw new Error('appRegistryDapp is required for installApp operation.');
    }
    const targetAddress = target === 'space' ? fnArgs.spaceAddress : fnArgs.userAddress;
    const onAppInstallCallData = new Uint8Array(0); // TODO: not supported in v0
    const toInstallAppCallData = appRegistryDapp.installer.interface.encodeFunctionData('installApp', [appAddress, targetAddress, onAppInstallCallData]);
    return smartAccount.sendUserOp({
        toAddress: [appRegistryDapp.installer.address],
        callData: [toInstallAppCallData],
        signer,
        value: [price],
        spaceId: target === 'space' ? fnArgs.spaceAddress : undefined,
        functionHashForPaymasterProxy: 'installApp',
    });
}
